<template lang="pug">
#app.layout.layout--iframe
  #content
    nuxt

  #full-message.full-message(
    v-if="message"
    :data-type="message.type")
    .full-message__icon
      i.bx.bx-check-circle(v-if="message.type === 'success'")
      i.bx.bx-x-circle(v-if="message.type === 'error'")
    .full-message__title {{ message.title }}
    .full-message__content {{ message.content }}
    .full-message__close(v-if="message.closable" @click="closeMessage") Close
</template>

<script>
const BROADCAST_EVENT_TYPE = 'pod-iframe-resize'

export default {
  name: 'IframeLayout',

  provide () {
    return {
      broadcast: message => {
        this.message = message
      }
    }
  },

  data () {
    return {
      observer: null,
      message: null,
      width_: null, // broadcasted
      height_: null // broadcasted
    }
  },

  head () {
    return {
      bodyAttrs: {
        class: 'embedded'
      },
      htmlAttrs: {
        class: 'embedded'
      }
    }
  },

  mounted () {
    // this.tick()
    this.observer = new ResizeObserver(this.tick)
    this.observer.observe(document.documentElement)
  },

  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },

  methods: {
    tick () {
      const width = document.documentElement.offsetWidth
      const height = document.documentElement.offsetHeight
      const route = this.$route.name.replace((/^iframes-/), '')
      if (this.width_ === width && this.height_ === height) return
      window.parent
        .postMessage({
          type: BROADCAST_EVENT_TYPE,
          route,
          width,
          height
        }, '*')
      this.width_ = width
      this.height_ = height
    },

    closeMessage () {
      this.message = null
    }
  }
}
</script>

<style lang="scss">
html, body {
  &.embedded {
    background: white;
  }
}
</style>

<style lang="scss" scoped>
#app {
  position: relative;
}
#content,
#full-message {
  padding: 16px;
}
.full-message {
  color: white;
  position: fixed;
  inset: 0;
  z-index: 10000;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &[data-type="success"] {
    background: darken($--color-success, 10);
  }
  &[data-type="error"] {
    background: darken($--color-danger, 15);
  }
  &__icon {
    font-size: 64px;
  }
  &__title {
    font-size: 24px;
  }
  &__content {
    font-size: 16px;
    color: rgba(white, 0.8);
    margin: 1em 0;
  }
  &__close {
    margin-top: 1em;
    font-size: 14px;
    cursor: pointer;
    padding: 10px 16px;
    border-radius: 1000px;
    border: 1px solid rgba(white, 0.8);
  }
}
</style>
